/**
 * Stage 5E.2 Phase 3 — neutral loading shell + firm-first wrapper.
 *
 * BrandLoadingSkeleton renders a neutral, brand-agnostic placeholder
 * while the authoritative brand context is unresolved. It DOES NOT
 * show Ordly identity (no logo, no Ordly accent) so a subsequent
 * resolve to ``firm_first`` does not flash from Ordly to firm — the
 * page goes from neutral → firm directly.
 *
 * FirmFirstShell holds the skeleton while ``resolved === false`` and
 * renders the firm/Ordly children once resolution completes. There is
 * NO timer-based fallback: elapsed time never decides the brand
 * identity (contract §8). Only ``error === true`` on the upstream
 * provider (confirmed resolver failure) flips to the safe Ordly
 * fallback.
 */
import React from "react";
import { useBrand } from "./BrandProvider";

export function BrandLoadingSkeleton({ "data-testid": testId }) {
    // Neutral colour-agnostic skeleton — no logo, no Ordly accent,
    // no firm accent. Pure shell.
    return (
        <div
            data-testid={testId || "brand-loading-skeleton"}
            className="brand-loading-skeleton"
            aria-hidden="true"
            style={{
                minHeight: "100vh",
                background: "var(--brand-loading-bg, #f5f5f5)",
            }}
        />
    );
}

export function FirmFirstShell({ children, skeletonTestId }) {
    const { resolved } = useBrand();
    if (!resolved) {
        return <BrandLoadingSkeleton data-testid={skeletonTestId} />;
    }
    return children;
}
